import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
export function useDeviationAttributes(deviation, isOwner) {
    var spacingExperiment = useFlag('actionbar_spacing');
    var isExtendedLoaded = !!deviation.extended;
    var isSimple = [
        DeviationTypes.COMMISSION,
        DeviationTypes.STATUS,
        DeviationTypes.POLL,
    ].includes(getDeviationType(deviation));
    return {
        hasFlag: !!deviation.dailyDeviation,
        isLoveable: !isSimple,
        isCommentable: spacingExperiment || (isExtendedLoaded && deviation.isCommentable),
        isFavouritable: !isSimple,
        isGroupSubmittable: (isExtendedLoaded || spacingExperiment) && !isSimple,
        isDownloadable: deviation.isDownloadable &&
            (spacingExperiment ||
                (isExtendedLoaded &&
                    !!(deviation.extended && deviation.extended.download))),
        isPurchasable: isExtendedLoaded && !!(deviation.extended && deviation.extended.pcp),
        isShareable: spacingExperiment || (deviation.isShareable || isSimple),
        isReportable: !isOwner,
        isPrintPurchasable: isExtendedLoaded && !!deviation.printId,
        isEditable: (isExtendedLoaded || spacingExperiment) && isOwner,
    };
}
//# sourceMappingURL=useDeviationAttributes.js.map